import React from 'react'
import { Grid, Box } from '@mui/material'
import { compact } from '@/utils/lodash'
import { PropertyCardPublic } from '@/housefolios-components/Property/PropertyCard'
import { PropertyListPublic } from '@/housefolios-components/Property/PropertyList'
import {
  PropertyCardSkeleton,
  PropertyListSkeleton,
} from '@/housefolios-components/Property/PropertyCardSkeleton'
import AllPropertiesFiltered from '@/housefolios-components/Properties/AllPropertiesFiltered'
import EmptyMarketplace from '@/housefolios-components/Marketplace/EmptyMarketplace'
import FetchMore from '@/housefolios-components/Properties/MyProperties/FetchMore'
import Pagination from '@mui/material/Pagination'

/**
 * Main content component for marketplace page
 * Handles both card and list views with pagination
 */
const MarketplaceContent = ({
  activeTab,
  properties,
  unfilteredProperties,
  marketplace,
  subdomainParam,
  handleRequestSort,
  page,
  setPage,
  count,
  handlePageChange,
  currentPageProperties,
  ordering,
  setOrdering,
  fetchMoreProperties,
  hasNextPage,
  cursor,
  sold,
  loading = false,
}) => {
  if (loading) {
    return activeTab === '2' ? (
      <PropertyListSkeleton />
    ) : (
      <PropertyCardSkeleton count={8} isPublic />
    )
  }

  if (compact(properties).length > 0) {
    return (
      <>
        {activeTab === '2' && (
          <Grid
            size={12}
            sx={{
              width: '100%',
              maxWidth: '100%',
              minWidth: 0,
              overflow: 'hidden',
            }}
          >
            <PropertyListPublic
              properties={properties}
              marketplace={marketplace || 'null'}
              shared
              subdomainParam={subdomainParam}
              handleRequestSort={handleRequestSort}
              page={page}
              setPage={setPage}
              count={count}
              handlePageChange={handlePageChange}
              currentPageProperties={currentPageProperties}
              ordering={ordering}
              setOrdering={setOrdering}
            />
            <FetchMore
              fetchMoreProperties={fetchMoreProperties}
              loadMore={hasNextPage}
              cursor={cursor}
            />
          </Grid>
        )}
        {activeTab !== '2' && (
          <>
            <Grid
              size={12}
              sx={{ width: '100%', maxWidth: '100%', minWidth: 0 }}
            >
              <Grid
                container
                spacing={4}
                sx={{ width: '100%', p: '20px' }}
              >
              {currentPageProperties.map((property) => (
                <PropertyCardPublic
                  key={property._id}
                  property={property}
                  marketplace={marketplace || 'null'}
                  shared
                  subdomainParam={subdomainParam}
                />
              ))}
              </Grid>
            </Grid>
            <Grid size={12}>
              <FetchMore
                fetchMoreProperties={fetchMoreProperties}
                loadMore={hasNextPage}
                cursor={cursor}
              />
              <Box
                sx={{
                  p: '1rem',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <Pagination size="small" count={count} page={page} onChange={handlePageChange} />
              </Box>
            </Grid>
          </>
        )}
      </>
    )
  }

  if (unfilteredProperties?.length > 0) {
    return <AllPropertiesFiltered />
  }

  return <EmptyMarketplace sold={sold} />
}

export default MarketplaceContent
